import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import '@mdi/font/css/materialdesignicons.css'
Vue.use(Vuetify)
export default new Vuetify({
  // IE에서 작동 하지 않으므로 AppHeader.vue파일의 changeColor() 메소드를 참고 하여 바꿀 수 있습니다.
  theme: {
    dark: true,
    themes: {
      light: {
        hcardsearch: '#FEFEFE', // 조회 조건 card
        hcardsearchbg: '#0784F2', // 조회 조건 card background
        hcardinput: '#FEFEFE', // 입력 card
        hcardinputbg: '#0784F2', // 입력 card background
        hcomponent: '#0784F2', // 입력 컴포넌트 기본
        hcomponentbg: '#FEFEFE', // 입력 컴포넌트 background
        htab: '#D9E4EF', // 텝 기본
        htabbg: '#D9E4EF', // 텝 기본 background
        htab2: '#F8F8FA', // 텝 2단 기본
        htab2bg: '#F8F8FA', // 텝 2단 background
        hth: '#f2f6f6', // 테이블 헤더 배경색
        hthtext: '#424C60', // 테이블 헤더 글자색
        hthline: '#E4EAF1', // 테이블 헤더 라인색
        htb: '#F8F8FA', // 테이블 내용 배경색
        htbtext: '#74849E', // 테이블 내용 글자색
        htbline: '#E6E6E6', // 테이블 내용 라인
        hrequired: '#FF3400', // 필수 입력 색
        hpopbody: '#F1F1F1', // popup 카드 기본색
        txtfieldbg: '#E6ECF3', // 텍스트 필드 배경색
        txtblue: '#1255a5', // 텍스트 블루
        txtgreen: '#6ead00', // 텍스트 그린
        txtred: '#d42a46', // 텍스트 레드
        // scrollbar: '#95b4b4', // 스크롤바 색상
        scrollbar: '#0784f2', // 스크롤바 색상
        scrollbarbg: '#cad4d4', // 스크롤바 배경
        inquiry: '#FDFDFD',
        btnbg: '#014085', // 버튼 기본 배경 색상
        btntext: '#000000', // 버튼 기본 텍스트 색상
        // cardbg: '#d9e6e6',
        cardbg: '#1255a5',
        cardtextbg: '#ffffff',
        cardtextbg2: '#f5f8f7',
        cardtitle: '#a0cbcb',
        normalBtnBg: '#eefdea',
        normalBtntext: '#abf394',
        premiumBtnBg: '#fbe7e7',
        premiumBtntext: '#ef9b9b',
        subTab: '#d1e0ef',
        borderColor: '#929292',
        fontColorAqua: '#00afaf',
        fontColorLightGreen: '#6eb36e',
        lightG: '#24943e',
        aquaG: '#014085',
        sidocard: '#FFFFFF',
        white: '#FFF',
        personBg: '#b2b2b2',
        cctvIconBg: '#0784f2'
      },
      dark: {
        hcardsearch: '#3E425A', // 조회 조건 card
        hcardsearchbg: '#3E425A', // 조회 조건 card background
        hcardinput: '#3E425A', // 입력 card
        hcardinputbg: '#5C6281', // 입력 card background
        hcomponent: '#5C6281', // 입력 컴포넌트 기본
        hcomponentbg: '#3E425A', // 입력 컴포넌트 background
        htab: '#3E425A', // 텝 기본
        htabbg: '#3E425A', // 텝 기본 background
        htab2: '#2F334A', // 텝 2단 기본
        htab2bg: '#2F334A', // 텝 2단 background
        hth: '#373b52', // 테이블 헤더 배경색
        hthtext: '#DFE1EE', // 테이블 헤더 글자색
        hthline: '#474B6B', // 테이블 헤더 라인색
        htb: '#2F334A', // 테이블 내용 배경색
        htbtext: '#b5b8db', // 테이블 내용 글자색
        htbline: '#3E425E', // 테이블 내용 라인
        hrequired: '#FF3400', // 필수 입력 색
        hpopbody: '#2A3147', // popup 카드 기본색
        txtfieldbg: '#747488', // 텍스트 필드 배경색
        txtblue: '#2196f3', // 텍스트 블루
        txtgreen: '#6ead00', // 텍스트 그린
        txtred: '#d42a46', // 텍스트 레드
        scrollbar: '#3e4e69', // 스크롤바 색상
        scrollbarbg: '#5a667b', // 스크롤바 배경
        inquiry: '#3E425A',
        btnbg: '#2196f3', // 버튼 기본 배경 색상
        btntext: '#FFFFFF', // 버튼 기본 텍스트 색상
        cardbg: '#6e7e9e',
        cardtextbg: '#2d3752',
        cardtextbg2: '#303b56',
        cardtitle: '#3e4e69',
        normalBtnBg: '#394e4d',
        normalBtntext: '#76c067',
        premiumBtnBg: '#46384a',
        premiumBtntext: '#b5545a',
        subTab: '#42577f',
        borderColor: '#425694',
        fontColorAqua: '#00ffff',
        fontColorLightGreen: '#90ff90',
        lightG: '#90ee90',
        aquaG: '#00ffff',
        sidocard: '#4C5870',
        white: '#FFF',
        personBg: '#31384b',
        cctvIconBg: '#515e77'
      }
    },
    options: {
      customProperties: true
    }
  },
  icons: {
    iconfont: 'mdi'
  }
})
